import React, { Component } from 'react';
import { importAll } from './Utils.js';

import MediaQuery from 'react-responsive';

const css = require('./css.json');

const portraits = importAll(require.context('./content/chars', false, /\.(png|jpe?g|svg)$/));


class CharacterSelect extends Component {
    static defaultProps = { width:800 };

    onClick(e, x, y) {
        if (typeof this.props.selected === "function") {
            this.props.selected(css[y][x]);
        }
    }

    render() {
        console.log(Object.keys(portraits));
        let cssDiv = css.map(function(row, i) {
            return (
                <div key={"CharacterSelectRow" + i} className="flextest">{row.map(function(c, j) {
                      let key = 'CharacterSelect' + i + ',' + j;
                      return <img src={portraits[`${c}_0.png`]} key={key} alt={c} onClick={(e) => { this.onClick(e, j, i); }} />;
                    }, this)}
                </div>
            );
        }, this);

        let tiny = [];
        for (let i=0; i<css.length; i++) {
            for (let j=0; j<css[i].length; j++) {
                let key = 'CharacterSelect' + i + ',' + j;                
                tiny.push(<img src={portraits[`${css[i][j]}_0.png`]} key={key} onClick={(e) => { this.onClick(e, j, i); }} />);
            }
        }

        return (
            <div className="center-popup">
              <MediaQuery minWidth={900}>
                <div className="CharacterSelect">
                  { cssDiv }
                </div>
              </MediaQuery>
              <MediaQuery maxWidth={900}>
                <div className="CharacterSelect tiny">
                  { tiny }
                </div>                
              </MediaQuery>
            </div>
        );
    }
}

export default CharacterSelect;
